import { IOnInit } from "angular";
import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementService,
} from "../../../ui/authorizedUiElement";
import { vsServiceName as userDetailTabsServiceName } from "./service";

export class UserDetailController implements IOnInit {
  static $inject = [userDetailTabsServiceName];

  constructor(
    private readonly userDetailTabsService: AuthorizedUiElementService<AuthorizedUiElementConfig>
  ) {}

  $onInit(): void {}
}
